<template>
  <div class="ibox selected overview-box">
    <div class="title">
      <strong>{{title}}</strong>
    </div>
    <div class="content border-left-right text-center" v-if="(avatarName || avatarImage) && !loading">
      <Avatar :image="avatarImage" :name="avatarName" :circleMode="avatarCircleMode" :editable="avatarEditable" @editImage="$emit('editImage', $event)" @removeImage="$emit('removeImage', $event)" />
    </div>
    <div class="content border-left-right text-center" v-if="loading">
      <SkeletonCircle height="128px" width="128px" radius="64px" />
    </div>
    <div class="content" :class="[(!avatarImage && !avatarName) ? 'profile-content' : '']">
      <slot/>
    </div>
  </div>
</template>

<style scoped lang="scss">
.overview-box {
  border-radius: $layout-border-radius;
  background-color: #ffffff;
}
.overview-box .title {
  border: none;
  border-bottom: 1px solid #f7f7f7;
  color: inherit;
  margin-bottom: 0;
  padding: 15px 90px 8px 15px;
  min-height: 48px;
  position: relative;
  clear: both;
}
.overview-box .content {
  clear: both;
  border: none;
  padding: 15px 20px 20px 20px;
}
</style>

<script>
import Avatar from '@/components/avatar'

export default {
  name: "OverviewBox",
  components: {
    Avatar
  },
  props: {
    title: String,
    loading: {
      type: Boolean,
      default: false
    },
    avatarImage: String,
    avatarName: String,
    avatarEditable: Boolean,
    avatarCircleMode: {
      type: Boolean,
      default: true
    }
  }
};
</script>